import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./phone.css";
export default function PhoneFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record;
    var value = useMemo(function () {
        var r = record || {};
        return fieldName && r[fieldName];
    }, [record, fieldName]);
    var buttonStyle = {
        border: "none",
        background: "none",
    };
    return (_jsx(_Fragment, { children: value && (_jsx(PhoneInput, { country: "fr", value: value, inputProps: {
                readOnly: true,
            }, disableDropdown: true, buttonStyle: buttonStyle, inputStyle: {
                border: "none",
                background: "none",
                paddingLeft: "30px",
            } })) }));
}
